import axios from 'axios';
import { API } from '../utils/static-data';
import { getAuthHeader } from '../utils/utils';

class ActivityService {

  static async getActivities(organism) {
    try {
      const result = await axios.get(`${API}/activity/byOrganism/${organism}`, {
        headers: {
          ...getAuthHeader()
        }
      });

      return result.data;
    } catch (error) {
      throw new Error("Ha ocurrido un error al obtener la información.")
    }
  }

  static async getPhoto(id) {
    try {
      const photo = await axios.get(`${API}/activity/getImage/${id}`, {
        headers: {
          ...getAuthHeader(),
        },
        responseType: 'blob'
      });
      return photo;
    } catch (error) {
      throw new Error('Error al descargar la imagen');
    }
  }

  static async getPdf(id, withImages = false) {
    try {
      const pdf = await axios.get(`${API}/activity/print/${id}`, {
        headers: {
          ...getAuthHeader()
        },
        responseType: 'blob'
      });
      return pdf;
    } catch (error) {
      throw new Error('Error al descargar archivo PDF');
    }
  }

  static async printActivitiesWithConfig(start = null, end = null, location = null, organism = null, status = null) {
    try {
      const url = `${API}/activity/printByDateRange${start ? `?start=${start / 1000}` : ''}${end ? `&end=${end / 1000}` : ''}${location ? `&location=${location}` : ''}${organism ? `&organism=${organism}` : ''}${status ? `&status=${status}` : ''}`;
      const result = await axios.get(url, {
        headers: {
          ...getAuthHeader()
        },
        responseType: 'blob'
      });
      return result.data;
    } catch (error) {
      throw new Error("Ha ocurrido un error al obtener la información.")
    }
  }

  static async getActivityTableByDateRange(range, organism) {
    try {
      const url = `${API}/activity/getActivityTableByDateRange?start=${range.start}&end=${range.end}${organism ? `&organism=${organism}` : ''}`;
      const result = await axios.get(url, {
        headers: {
          ...getAuthHeader()
        },
        responseType: 'blob'
      });
      return result.data;
    } catch (error) {
      throw new Error("Ha ocurrido un error al obtener la información.");
    }
  }

  static async getActivitiesWithConfig(start = null, end = null, location = null, organism = null, status = null) {
    try {
      const url = `${API}/activity/getByDateRange${start ? `?start=${start / 1000}` : ''}${end ? `&end=${end / 1000}` : ''}${location ? `&location=${location}` : ''}${organism ? `&organism=${organism}` : ''}${status ? `&status=${status}` : ''}`;
      const result = await axios.get(url, {
        headers: {
          ...getAuthHeader()
        }
      });
      return result.data;
    } catch (error) {
      throw new Error("Ha ocurrido un error al obtener la información.")
    }
  }

  static async setGovernorPresence(id) {
    try {
      const result = await axios.get(`${API}/activity/setGovernorPresence/${id}`,
        {
          headers: {
            ...getAuthHeader()
          }
        });
      return result.data;
    } catch (error) {
      throw Error('Ha ocurrido un error');
    }
  }

  static async createActivity(activity) {
    try {
      const result = await axios.post(`${API}/activity`,
        activity,
        {
          headers: {
            ...getAuthHeader()
          }
        });
      return result.data;
    } catch (error) {
      throw Error('Ha ocurrido un error');
    }
  }

  static async finishActivity(activity, data) {
    try {
      const result = await axios.patch(`${API}/activity/finishActivity/${activity}`,
        data,
        {
          headers: {
            ...getAuthHeader()
          }
        });
      return result.data;
    } catch (error) {
      throw Error('Ha ocurrido un error');
    }
  }

  static async postponeActivity(activity, date) {
    try {
      const result = await axios.patch(`${API}/activity/toDiffer/${activity}`,
        {
          date
        },
        {
          headers: {
            ...getAuthHeader()
          }
        });
      return result.data;
    } catch (error) {
      throw Error('Ha ocurrido un error');
    }
  }

}

export default ActivityService;
